import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import { SmallPrint } from '../ReferralContent/ReferralContent.styles'
import { Text, NumberItem } from './SchoolStatusBanner.styles'

const messages = defineMessages({
  teacherNumber: {
    id: 'dashboard.referrals.teacherNumber',
    defaultMessage: 'teachers in your school'
  },
  teacherNumberSingle: {
    id: 'dashboard.referrals.teacherNumberSingle',
    defaultMessage: 'teacher in your school'
  },
  numberToGo: {
    id: 'dashboard.referrals.numberToGo',
    defaultMessage: 'more to go'
  },
  smallPrintText: {
    id: 'dashboard.referrals.schoolSmallPrintText',
    defaultMessage:
      'You need at least 6 total subscribing teachers in your school to claim this offer. Max £100 vouchers per school.'
  }
})

export default class SchoolStatusBanner extends Component {
  static propTypes = {
    teachers: PropTypes.array
  }

  render () {
    const { teachers } = this.props
    const numberToGo = (teachers && 6 - teachers.length) || 6

    return (
      <Fragment>
        <Text type='main'>
          <NumberItem>{teachers.length || 0}</NumberItem>
          &nbsp;
          {teachers.length === 1 ? <FormattedMessage {...messages.teacherNumberSingle} /> : <FormattedMessage {...messages.teacherNumber} />}
          &nbsp;=&nbsp;
          <NumberItem>{numberToGo}</NumberItem>
          &nbsp;
          <FormattedMessage {...messages.numberToGo} />
          *
        </Text>
        <SmallPrint type='regularBlue'>
          *
          <FormattedMessage {...messages.smallPrintText} />
        </SmallPrint>
      </Fragment>
    )
  }
}
